(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector(".testimonials-grid");
  const cards = document.querySelectorAll(".testimonial-card");
  const prevBtn = document.getElementById("prevBtn");
  const nextBtn = document.getElementById("nextBtn");

  if (window.innerWidth <= 600) {
    let currentIndex = 0;
    const update = () => {
      const cardWidth = cards[0].offsetWidth + 30;
      slider.style.transform = `translateX(-${currentIndex * cardWidth}px)`;
    };
    const next = () => { currentIndex = (currentIndex + 1) % cards.length; update(); };
    const prev = () => { currentIndex = (currentIndex - 1 + cards.length) % cards.length; update(); };
    nextBtn.addEventListener("click", next);
    prevBtn.addEventListener("click", prev);
    update();
  }
});

  } catch(e) { console.error(e); }
})();
})();
